<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>对账管理</el-breadcrumb-item>
        <el-breadcrumb-item>物美</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="160px">
        <el-form-item label="对账日期：">
          <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"> </el-date-picker>
          <el-button style="margin-left: 20px" type="primary" @click="generateData">生成</el-button>
          <el-button style="margin-left: 20px" type="success" @click="loadData">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="box-shadow">
      <div class="box-container">
        <div v-if="billList && billList.length > 0">
          <div v-for="(item, index) in billList" :key="index" v-loading="isLoading" element-loading-text="拼命生成中">
            <div class="title-container">
              <h2></h2>
              <h2>{{ item.settlementName }}</h2>
              <h2 style="color: green">{{ item.status | statusMap }}</h2>
            </div>

            <div class="btn-container">
              <el-button v-show="item.status === 10" type="primary" @click="generateBill(item.id)">生成对账单</el-button>
              <el-button v-show="item.status === 30 || item.status === 40" type="success" @click="downloadBill(item.downloadUrl)"> 下载 </el-button>
              <el-button v-show="item.status === 30" type="danger" @click="confirmAndPay(item.id)">双方已确认并打款</el-button>
            </div>
          </div>
        </div>
        <div v-else>
          <h2>暂无数据</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateRange: [],
      pickerOptions: {},
      listParams: {
        sectionStart: "",
        sectionEnd: "",
      },
      billList: [],
      isLoading: false,
    };
  },

  mounted() {
    this.loadDateRange();
    this.loadData();
  },
  filters: {
    statusMap(val) {
      let statusStr = "";
      switch (val) {
        case 10:
          statusStr = "待生成对账单";
          break;
        case 20:
          statusStr = "生成中";
          break;
        case 30:
          statusStr = "生成完成";
          break;
        case 40:
          statusStr = "双方已确认并打款";
          break;
        default:
          statusStr = "";
          break;
      }
      return statusStr;
    },
  },

  methods: {
    /**
     * @description: 获取账单领货日期区间
     * @param {*}
     * @return {*}
     */
    loadDateRange() {
      this.$http({
        url: global.apiUrl + "/settlement/wmOrRtBillDataSection",
        method: "GET",
      }).then(res => {
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          const sectionStart = res.body.data.sectionStart;
          const sectionEnd = res.body.data.sectionEnd;
          this.pickerOptions = {
            disabledDate(time) {
              return time.getTime() < new Date(sectionStart).getTime() || time.getTime() > new Date(sectionEnd).getTime() - 24 * 60 * 60 * 1000;
            },
          };
        }
      });
    },
    /**
     * @description: 获取对账列表
     * @param {*}
     * @return {*}
     */
    loadData() {
      this.$http({
        url: global.apiUrl + "/settlement/wmBillList",
        method: "GET",
      }).then(res => {
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          this.billList = res.body.data?.dataList;
        }
      });
    },
    /**
     * @description: 生成对账列表
     * @param {*}
     * @return {*}
     */
    generateData() {
      const queryParams = {};
      if (this.dateRange.length > 0) {
        const sectionStart = this.formatDate(this.dateRange[0]);
        const sectionEnd = this.formatDate(this.dateRange[1]);
        Object.assign(queryParams, {
          sectionStart,
          sectionEnd,
        });
      }
      this.$http({
        url: global.apiUrl + "/settlement/wmBillDataSectionConfirm",
        method: "POST",
        body: queryParams,
      }).then(res => {
        if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
          this.loadData();
        } else {
        }
      });
    },
    /**
     * @description: 格式化日期
     * @param {*} date
     * @return {*}
     */
    formatDate(date) {
      const formatDate = new Date(date);
      const year = formatDate.getFullYear();
      const month = this.complement(formatDate.getMonth() + 1);
      const day = this.complement(formatDate.getDate());
      return year + "-" + month + "-" + day;
    },
    complement(val) {
      val = parseInt(val);
      if (val < 10) {
        return "0" + val;
      } else {
        return val;
      }
    },
    /**
     * @description: 生成对账单
     * @param {*} id
     * @return {*}
     */
    generateBill(id) {
      this.isLoading = true;
      this.$http({
        url: global.apiUrl + "/settlement/wmBill",
        method: "POST",
        body: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success("生成对账单成功");
            this.loadData();
          } else {
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /**
     * @description: 下载文件
     * @param {*} url
     * @return {*}
     */
    downloadBill(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    /**
     * @description: 双方确认并打款
     * @param {*} id
     * @return {*}
     */
    confirmAndPay(id) {
      this.$confirm("双方确认并打款 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: global.apiUrl + "/settlement/finishSettlement",
            method: "POST",
            body: { id },
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                this.loadData();
              } else {
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.box-container {
  width: auto;
  padding: 20px;
  border-radius: 6px;
  text-align: center;
  .title-container {
    display: flex;
    justify-content: space-between;
  }
  .btn-container {
    margin-top: 20px;
  }
}
</style>
